import { createMuiStyles } from '../../../../utils/mui';

export const eligibilitySectionStyles = createMuiStyles({
  illustration: {
    height: '5rem',
    width: 'auto',
    display: 'block',
  },
});
